import MobileOnlyLink from '@acorn-portal/shared/src/components-v2/mobile-only-link';
import { Typography } from '@mui/material';

interface IRenewalNotificationContent {
	contactNumber: string;
}

/**
 * - Simple component to display a notification when a policy is blocked by being in the renewal period
 */
const RenewalNotificationContent = ({ contactNumber }: IRenewalNotificationContent) => {
	return (
		<Typography>
			Your policy is now in the renewal period. Please call us
			{contactNumber ? (
				<>
					{' '}
					on <MobileOnlyLink href={`tel:${contactNumber}`} text={contactNumber} />
				</>
			) : null}{' '}
			and we&apos;ll help you with your cancellation request.
		</Typography>
	);
};

export default RenewalNotificationContent;
